/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanityTokenItemHolderInfo = {
    ADDR: string;
    ADDRTYTP: HumanityTokenItemHolderInfo.ADDRTYTP;
    QTY: string;
    PER: string;
};

export namespace HumanityTokenItemHolderInfo {

    export enum ADDRTYTP {
        EOA = 'EOA',
        CA = 'CA',
    }


}

